module.exports = __webpack_public_path__ + "static/img/bofangluyin.b109543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/bofangluyin.png
// module id = FxXu
// module chunks = 24